import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { adminGuard } from 'app/core/auth/guards/admin.guard';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

export const appRoutes: Route[] = [

    // Home
    {path: '', pathMatch: 'full', redirectTo: 'dashboard'},
    {path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboard'},

    // Pagine di accesso (solo per chi non è collegato)
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {layout: 'empty'},
        children: [
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
        ],
    },

    // Conferma email (accessibile a tutti: il link arriva per email)
    {
        path: '',
        component: LayoutComponent,
        data: {layout: 'empty'},
        children: [
            {path: 'confirm-email', loadChildren: () => import('app/modules/auth/confirm-email/confirm-email.routes')},
        ],
    },

    // Uscita
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {layout: 'empty'},
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
        ],
    },

    // Area riservata
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {initialData: initialDataResolver},
        children: [
            {path: 'dashboard', loadChildren: () => import('app/modules/admin/dashboard/dashboard.routes')},
            {path: 'partners', loadChildren: () => import('app/modules/admin/partners/partners.routes')},
            {path: 'last-minute', loadChildren: () => import('app/modules/admin/offers/last-minute.routes')},
            {path: 'coupons', loadChildren: () => import('app/modules/admin/offers/coupons.routes')},
            {path: 'tickets', loadChildren: () => import('app/modules/admin/tickets/tickets.routes')},
            {path: 'subscriptions', loadChildren: () => import('app/modules/admin/subscriptions/subscriptions.routes')},
            {path: 'profile', loadChildren: () => import('app/modules/admin/profile/profile.routes')},
            {path: 'users', canActivate: [adminGuard], loadChildren: () => import('app/modules/admin/users/users.routes')},
            {path: 'config', loadChildren: () => import('app/modules/admin/config/config.routes')},
            {path: 'promo', canActivate: [adminGuard], loadChildren: () => import('app/modules/admin/promo/promo.routes')},
            {path: 'partner-area', loadChildren: () => import('app/modules/admin/partner-area/partner-area.routes')},
            {path: 'interactions', loadChildren: () => import('app/modules/admin/interactions/interactions.routes')},
            {path: '**', redirectTo: 'dashboard'},
        ],
    },
];
